// src/api/utils/csrfUtils.js

// CSRF 토큰을 서버로부터 요청하는 함수 (이미 구현되어 있다고 가정)
import { fetchCsrfToken } from '../csrf';  // 기존 fetchCsrfToken 임포트

/**
 * CSRF 토큰이 쿠키에 존재하는지 확인하고, 없을 경우 서버에 요청하여 갱신하는 함수
 */
export const ensureCsrfToken = async () => {
  // 브라우저의 쿠키 문자열을 세미콜론+공백 기준으로 분리한 후,
  // 'XSRF-TOKEN='으로 시작하는 항목을 찾아 해당 값을 추출
  const xsrfToken = document.cookie
    .split('; ')
    .find(row => row.startsWith('XSRF-TOKEN=')) // 'XSRF-TOKEN' 쿠키 찾기
    ?.split('=')[1]; // 값만 추출 (쿠키는 '이름=값' 형식)

  // 쿠키에 XSRF-TOKEN이 없으면
  if (!xsrfToken) {
    console.warn('[csrfUtils] ⚠️ 쿠키에 XSRF-TOKEN 없음 → 요청');

    // 서버에 CSRF 토큰을 요청하여 쿠키로 갱신
    await fetchCsrfToken();

    console.log('[csrfUtils] ✅ CSRF 토큰 갱신 완료');
  } else {
    // 쿠키에 CSRF 토큰이 이미 존재하면 로그 출력
    console.log('[csrfUtils] 🍪 쿠키에서 XSRF-TOKEN 확인됨:', xsrfToken);
  }
};
